import { createRoot } from 'react-dom/client';
import videojs from 'videojs-mux-kit';
import createUsageTracker from './tracker';
import StaticToggle from '../components/StaticToggle';
import { parseQueryParams } from 'video-embed/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoJSComponent = videojs.getComponent('Component');
class AutoplayToggle extends VideoJSComponent {
  constructor(player, options) {
    super(player, options);
    this.root = null;
    this.onToggle = () => {
      this.player().trigger('autoplaytoggle');
      this.tracker.track('playerInteraction', {
        action: 'autoplay-toggle'
      });
    };
    this.checkIfTrue = value => {
      return value === 'true' || value === '1';
    };
    this.mount = () => {
      const autoplay = parseQueryParams(window.location.search).autoplay;
      const autoPlay = parseQueryParams(window.location.search).autoPlay;
      const initialOn = this.checkIfTrue(autoplay) || this.checkIfTrue(autoPlay);
      if (this.root) {
        return;
      }
      this.root = createRoot(this.el());
      this.root.render( /*#__PURE__*/_jsx(StaticToggle, {
        onToggle: this.onToggle,
        initialOn: initialOn
      }));
    };
    this.el().className = this.buildCSSClass();
    this.tracker = createUsageTracker(); // defer call until plugin setup to ensure start.ts has already called createUsageTracker with initial props

    player.ready(() => {
      this.mount();
    });
    this.on('dispose', () => {
      var _this$root;
      (_this$root = this.root) === null || _this$root === void 0 || _this$root.unmount();
      this.root = null;
    });
  }
  buildCSSClass() {
    return `vjs-control vjs-playback-options ${super.buildCSSClass()}`;
  }
}
VideoJSComponent.registerComponent('AutoplayToggle', AutoplayToggle);